<script>
    import PromptContent from "commerce/prompt-content/prompt-content.svelte";
    import Currency      from "commerce/currency/currency.svelte";
    import Sub           from "commerce/sub/sub.svelte";
    import Spinner       from "commerce/spinner/spinner.svelte";

    import stsRequest from "commerce/lib/sts-request";
    import log        from "commerce/lib/send-log";

    import { loadQuotes } from "lib/load-quotes";

    import { prompt }              from "stores/prompt";
    import { activeQuote }         from "stores/active-quote";
    import { disableButtons, dim } from "stores/toggles";

    import { game } from "native";

    import css from "./prompt.css";

    const i18n = window.strings.exchange;

    /**
     * Update quotes if player attempts exchange and quotes are old
     */
    function clickRefresh() {
        disableButtons.set(true);

        loadQuotes().then(() => {
            disableButtons.set(false);
            prompt.setPrompt("confirm");
            // reloadVisibleQuotes();
            // quotes.hoverOffer
        });
    }

    /**
     * Complete exchange after confirmation
     */
    function clickTrade() {
        disableButtons.set(true);
        prompt.setPrompt("pending");

        log({
            action           : "interaction",
            interaction      : `ConfirmBuy-${$activeQuote.type}`,
            exchangePrice    : $activeQuote.price,
            exchangeQuantity : $activeQuote.quantity
        });

        return stsRequest({
            type     : "None",
            protocol : "Game.gw2.Exchange",
            command  : "Trade",
            body     : {
                CoinsPerGem       : $activeQuote.coins_per_gem,
                Quantity          : $activeQuote.price,
                QuantityToReceive : $activeQuote.quantity,
                Type              : $activeQuote.command
            }
        })
        .then(() => {
            prompt.setPrompt("success");
            disableButtons.set(false);

            loadQuotes();
        })
        .catch((err) => {
            const error = err.body || err;

            log({
                action           : "interaction",
                interaction      : `ErrorBuy-${$activeQuote.type}`,
                exchangePrice    : $activeQuote.price,
                exchangeQuantity : $activeQuote.quantity
            });

            if (error && !GW2.config.errors.includes(error.code)) {
                return game.call("ShowNetErrorBasic", error.code || 0, error.product || 0, error.module || 0, error.line || 0);
            }

            prompt.setPrompt(error.code === 49 ? "young" : "expired");
            disableButtons.set(false);
        });
    }

    /**
     * Close prompt
     */
    function clickClose() {
        if ($activeQuote.type) {
            log({
                action           : "interaction",
                interaction      : `CancelTransaction-${$activeQuote.type}`,
                exchangePrice    : $activeQuote.price,
                exchangeQuantity : $activeQuote.quantity
            });
        }

        prompt.clearPrompt();
        dim.set(false);
        activeQuote.clear();
    }

    $: buying = $activeQuote.type;
    $: buyingWith = buying === "gems" ? "coins" : "gems";
</script>

{#if $prompt === "confirm"}
    <PromptContent hideFn={clickClose}>
        <h2 class="{css.heading}">
            <Sub str={i18n.confirm.title} key="amount">
                <Currency type={buying} amount={$activeQuote.quantity} />
            </Sub>
        </h2>
        <div class="{css.content} serif">
            {i18n.confirm.cost}
            <Currency type={buyingWith} amount={$activeQuote.price} />
        </div>
        <div>
            <button class="{css.promptBtn}" on:click={clickTrade}>{i18n.confirm.trade}</button>
            <button class="{css.promptBtn}" on:click={clickClose}>{i18n.confirm.cancel}</button>
        </div>
    </PromptContent>

{:else if $prompt === "pending"}
    <PromptContent hideFn={clickClose}>
        <h2 class="{css.heading}">
            <Sub str={i18n.confirm.title} key="amount">
                <Currency type={buying} amount={$activeQuote.quantity} />
            </Sub>
        </h2>
        <div class="{css.content}">
            <Spinner />
        </div>
    </PromptContent>

{:else if $prompt === "success"}
    <PromptContent hideFn={clickClose}>
        <h2 class="{css.heading}">
            <Sub str={i18n.success.received} key="amount">
                <Currency type={buying} amount={$activeQuote.quantity} />
            </Sub>
        </h2>
        <div class="{css.content} serif">
            <p>{i18n.success.complete}</p>
            <p>{i18n.success.thanks}</p>
        </div>
        <div>
            <button class="{css.promptBtn}" on:click={clickClose}>{i18n.success.done}</button>
        </div>
    </PromptContent>

{:else if $prompt === "young" || $prompt === "expired"}
    <PromptContent>
        <h2 class="{css.heading}">{i18n.failure[$prompt].title}</h2>
        <div class="{css.content} serif">{i18n.failure[$prompt].text}</div>
        <div>
            <button class="{css.promptBtn}" on:click={$prompt === "young" ? clickClose : clickRefresh }>
                {i18n.failure.dismiss}
            </button>
        </div>
    </PromptContent>
{:else}
    {""}
{/if}
